import React, { Component } from 'react';

import  "./bbutil";
import BBIFrame from './BBIFrame';



class BBYasr extends BBIFrame {

  



  getUrl()
  {

    

    BBIFrame.scrolling="no";
    return "/bb/bbyasr.html";


   
  }
  
}



export default BBYasr;
